var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.cookieAccepted
    ? _c(
        "div",
        { staticClass: "app-cookie" },
        [
          _c(
            "div",
            { staticClass: "text" },
            [
              _vm._v("\n    " + _vm._s(_vm.$t("cookie-bar.text")) + "\n    "),
              _c(
                "router-link",
                {
                  staticClass: "cgu-link",
                  attrs: { to: { name: "cgu" }, target: "_blank" }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("cookie-bar.link")) + "\n    "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "x-button",
            {
              staticClass: "md-raised outline",
              on: { click: _vm.acceptCookie }
            },
            [_vm._v(_vm._s(_vm.$t("cookie-bar.button")))]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }